(function () {
  'use strict';

  angular
    .module('dtmService.module')
    .directive('dtmErrorFormField', ['dtmService', function (dtmService) {
      return {
        restrict: 'E',
        // templateUrl : 'scripts/directives/directive/directive.html' ,
        scope: {key: '=key', errorPrefix: '@errorPrefix'},
        link: function ($scope, $element, attrs) {
          if($scope.key && $scope.errorPrefix) {
             dtmService.exceptionFormFieldWithPrefix($scope.key, $element, $scope.errorPrefix);
          }else if ($scope.key){
             dtmService.exceptionFormField($scope.key, $element);
          }
        },
        controller: ['$scope', function($scope) {
          return this;
        }]

      };

    }]);
})();




